import React, { useEffect, useState } from 'react';
import { PaystackPayment } from './PaystackPayment';
interface CorporateTrainingFormProps {
  onSuccess?: (reference: string) => void;
}
export const CorporateTrainingForm: React.FC<CorporateTrainingFormProps> = ({
  onSuccess
}) => {
  const [formData, setFormData] = useState({
    companyName: '',
    contactPerson: '',
    email: '',
    phone: '',
    numberOfParticipants: 5,
    trainingTopics: [] as string[],
    preferredDate: '',
    additionalNotes: ''
  });
  const [isFormComplete, setIsFormComplete] = useState(false);
  const [totalAmount, setTotalAmount] = useState(250000);
  const trainingOptions = ['Networking & Relationship Building', 'Collaboration & Team Dynamics', 'Artificial Intelligence & Digital Tools', 'Digital Transformation Strategy', 'Leadership Development', 'Personal Branding & Professional Presence', 'Strategic Communication', 'Innovation & Creative Problem Solving'];
  useEffect(() => {
    const pricePerPerson = 50000;
    const calculatedAmount = formData.numberOfParticipants * pricePerPerson;
    setTotalAmount(calculatedAmount);
  }, [formData.numberOfParticipants]);
  const handleChange = (e: any) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    if (name === 'trainingTopics') {
      setFormData(prev => ({
        ...prev,
        trainingTopics: checked ? [...prev.trainingTopics, value] : prev.trainingTopics.filter(topic => topic !== value)
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: type === 'number' ? parseInt(value) : value
      }));
    }
    setTimeout(() => {
      const requiredFields = ['companyName', 'contactPerson', 'email', 'phone', 'numberOfParticipants', 'preferredDate'];
      const isComplete = requiredFields.every(field => formData[field]) && formData.email.includes('@') && formData.trainingTopics.length > 0;
      setIsFormComplete(isComplete);
    }, 100);
  };
  return <div className="w-full max-w-lg mx-auto" data-id="element-855">
      <div className="mb-6" data-id="element-856">
        <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-857">
          Corporate Training Request
        </h2>
        <p className="text-gray-600 mb-4" data-id="element-858">
          Transform your team with our expert-led training programs. ₦50,000 per
          participant per day.
        </p>
      </div>
      <div className="space-y-4 mb-6" data-id="element-859">
        <div data-id="element-860">
          <label htmlFor="companyName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-861">
            Company Name <span className="text-gray-500" data-id="element-862">(required)</span>
          </label>
          <input type="text" id="companyName" name="companyName" value={formData.companyName} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter company name" required data-id="element-863" />
        </div>
        <div data-id="element-864">
          <label htmlFor="contactPerson" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-865">
            Contact Person <span className="text-gray-500" data-id="element-866">(required)</span>
          </label>
          <input type="text" id="contactPerson" name="contactPerson" value={formData.contactPerson} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter contact person name" required data-id="element-867" />
        </div>
        <div data-id="element-868">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-869">
            Email <span className="text-gray-500" data-id="element-870">(required)</span>
          </label>
          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter email address" required data-id="element-871" />
        </div>
        <div data-id="element-872">
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-873">
            Phone Number <span className="text-gray-500" data-id="element-874">(required)</span>
          </label>
          <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter phone number" required data-id="element-875" />
        </div>
        <div data-id="element-876">
          <label htmlFor="numberOfParticipants" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-877">
            Number of Participants{' '}
            <span className="text-gray-500" data-id="element-878">(required, minimum 5)</span>
          </label>
          <input type="number" id="numberOfParticipants" name="numberOfParticipants" value={formData.numberOfParticipants} onChange={handleChange} min="5" className="w-full p-2 border border-gray-300 rounded-md" required data-id="element-879" />
          <p className="text-sm text-gray-600 mt-1" data-id="element-880">
            Total: ₦{totalAmount.toLocaleString()}
          </p>
        </div>
        <div data-id="element-881">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-882">
            Training Topics{' '}
            <span className="text-gray-500" data-id="element-883">(select at least one)</span>
          </label>
          <div className="space-y-2" data-id="element-884">
            {trainingOptions.map(option => <div key={option} className="flex items-center" data-id="element-885">
                <input type="checkbox" id={`topic-${option}`} name="trainingTopics" value={option} checked={formData.trainingTopics.includes(option)} onChange={handleChange} className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-886" />
                <label htmlFor={`topic-${option}`} className="text-gray-700" data-id="element-887">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-888">
          <label htmlFor="preferredDate" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-889">
            Preferred Training Date{' '}
            <span className="text-gray-500" data-id="element-890">(required)</span>
          </label>
          <input type="date" id="preferredDate" name="preferredDate" value={formData.preferredDate} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" required data-id="element-891" />
        </div>
        <div data-id="element-892">
          <label htmlFor="additionalNotes" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-893">
            Additional Notes <span className="text-gray-500" data-id="element-894">(optional)</span>
          </label>
          <textarea id="additionalNotes" name="additionalNotes" value={formData.additionalNotes} onChange={handleChange} rows={3} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Any specific requirements or questions?" data-id="element-895" />
        </div>
      </div>
      {isFormComplete ? <PaystackPayment amount={totalAmount} email={formData.email} name={formData.contactPerson} phone={formData.phone} onSuccess={onSuccess} metadata={{
      ...formData,
      service: 'Corporate Training'
    }} data-id="element-896" /> : <button disabled className="w-full py-2 px-4 bg-gray-300 text-gray-500 rounded-md cursor-not-allowed" data-id="element-897">
          Complete all required fields to proceed
        </button>}
    </div>;
};